module.exports = __webpack_public_path__ + "img/artboard8.135e5c46.png";